import "./InovicesList.css";
import { useState } from "react";
import AppFindContiner from "../../design/findContiner/AppFindContiner";
import InvoicesHead from "./InvoicesHead";
import InvoicesData from "./InvoicesData";


const AppInvoicesList = ({openNumDocket}) => {

    const templateData = () => {
        const template = {office: localStorage.getItem('office_number'), date_f: "", date_e: "", type: "*", status: "*"};
        const today = new Date();
        template['date_f'] = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        today.setDate(today.getDate() + 1);
        template['date_e'] = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        return template;
    }

    const [data, setData] = useState(templateData());

    return (<>
        <AppFindContiner 
        data={data} 
        setData={setData} 
        HeadComp={InvoicesHead} 
        DataComp={InvoicesData}
        className={"AppInvoicesList"}
        host={"invoices/filter"}
        propsData={{openNumDocket: openNumDocket}}
        />

    </>)
}

export default AppInvoicesList;